module.exports = __webpack_public_path__ + "img/img_index_link04.de027778.png";